import React from "react";
import { useTranslation } from "react-i18next";

const FormTextarea = ({
  label,
  name,
  value = "",
  onChange,
  placeholder,
  required = false,
  error,
  icon = null,
  additionalClass = "",
  lines = 4,
  maxLength = 450,
  showMaxLength = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-2 text-primary">
      {/* Label du champ */}
      <label className="block text-sm font-medium">
        {label}{" "}
        {required && <span className="text-muted">{t("modal.required")}</span>}
        {!required && <span className="text-muted">{t("modal.optional")}</span>}
      </label>

      {/* Zone de texte avec icône et compteur interne */}
      <div className="relative">
        {icon && (
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500 pointer-events-none">
            {icon}
          </span>
        )}

        <textarea
          name={name}
          value={value}
          maxLength={maxLength}
          onChange={(e) => onChange(name, e.target.value)}
          placeholder={placeholder}
          required={required}
          rows={lines || 4}
          className={`w-full bg-white shadow-md rounded-md border ${
            error ? "border-red-500" : ""
          }  px-4 py-3 pr-16 ${
            icon ? "pl-10" : ""
          } focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary ${additionalClass}`}
        />

        {/* Compteur de caractères dans le coin inférieur droit */}
        {maxLength && showMaxLength && (
          <span className="absolute bottom-2 right-3 text-gray-400 text-sm">
            {value.length} / {maxLength}
          </span>
        )}
      </div>

      {/* Affichage de l'erreur */}
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default FormTextarea;
